<template>
	<div id="searches">
		<p v-if="!searches.length" class="c-cp-total">{{$t("searches.title")}} : {{searches.length }}</p>
		<!-- <p><button v-on:click="remove()">Clear all</button></p> -->
		<ol class="c-saved-searches">
			<search
			v-on:remove="remove"
			v-for="search in searches" 
			:key="search.hash" 
			v-bind="search" 
			:trigger="trigger"
			v-on:openModal="openModal"
			v-on:logCopy="logCopy"
			/>
		</ol>
	</div>
</template>

<script>
	import LFPortal from '../portal/portal.js'
	import Search from './search.vue';
	export default {
		components: {Search},
	  name: 'searches',
	  props: ['searches'],
	  computed: {
	  	trigger(){
	  		return LFPortal.trigger('search');
	  	}
	  },
	  data () { return {};}, 
	  methods: {
			remove: function(hash){
				// console.log('Remove');
				LFPortal.Searches.remove(hash);
			},
			openModal: function(data){
				// Middle-man
				this.$emit('openModal', data);
			},
			logCopy: function(url){
				LFPortal.gaevent('SearchCopyLink', url);
			}
		}
	}
</script>	


// WEBPACK FOOTER //
// src/components/searches.vue